/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import {
  GenericLayout,
  SplashLayout,
  HeroicLayout,
  ErrorLayout
} from "Views/scaffolding/layouts";

/** Props needed to render a page. */
export type PageProps = {
  /** The actual content for the page. */
  content: string;
  /** The layout with which to render the page, defaults to "GENERIC". */
  layout?: "GENERIC" | "HEROIC" | "ERROR" | "SPLASH";
};

function Page(props: PageProps): JSX.Element {
  const { content, layout } = props;
  const copy = (
    <div
      css={css`
        width: 100%;
        word-wrap: break-word;
      `}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );

  switch (layout) {
    case "HEROIC":
      return <HeroicLayout>{copy}</HeroicLayout>;
    case "SPLASH":
      return <SplashLayout>{copy}</SplashLayout>;
    case "ERROR":
      return <ErrorLayout>{copy}</ErrorLayout>;
    default:
      return <GenericLayout>{copy}</GenericLayout>;
  }
}

const pageMemo = React.memo<PageProps>(Page);
export { pageMemo as Page };
